/* Вход экрана «Говорящий кружок» (03-api.md §6, entry; APP-SPEC-4 §2.4): «Кружок из аудио» (who: audio), «Видеооткрытка» (card),
   шаблон формата «кружок» (название шаблона, формат закреплён), voicePick, fmt; цена за единицу — app.price (ToolPrice). */
import type { StudioApp } from '../studio-api';
import { toolPrice } from './tool-helpers';
import type { CirclePreset, CircleWho } from './circle-model';
import type { CircleScreenOptions } from './use-circle-screen';

const record = (value: unknown): Record<string, unknown> => (value && typeof value === 'object' && !Array.isArray(value) ? (value as Record<string, unknown>) : {});
/** Шаблон закрепляет формат только при «Попробовать» на листе шаблона формата «Кружок» (APP-SPEC-4 §6.3): document_kind
    'app' сервер ставит любому приложению, в том числе базовому «Говорящему кружку» строки инструментов, поэтому признаком
    шаблона он не служит. Вход с who (source, fmt, format, card) шаблон снимает. */
export function circleEntry(app: StudioApp, initialInputs?: Record<string, unknown>, fromTemplateSheet = false): CircleScreenOptions {
  const entry = record(app.entry);
  const input = record(initialInputs);
  const who = String(entry.who ?? input.who ?? '');
  const appRecord = app as Record<string, unknown>;
  const fromEntry = ['who', 'source', 'fmt', 'format', 'card'].some(key => input[key] !== undefined);
  const template = fromTemplateSheet && !fromEntry && (appRecord.format === 'circle' || entry.fmt === 'circle') ? app.name : null;
  const preset: CirclePreset = { audio: who === 'audio' || input.source === 'audio', card: entry.card === true || input.card === true, template };
  return {
    preset,
    entryWho: ['char', 'me', 'person', 'photo', 'video', 'audio'].includes(who) ? (who as CircleWho) : null,
    entryFormat: typeof entry.fmt === 'string' ? entry.fmt : typeof input.fmt === 'string' ? input.fmt : null,
    voicePick: entry.voicePick === true || input.voicePick === true,
    unit: toolPrice(appRecord.price).amount,
  };
}

